'use client'

import { undefined } from 'effect/Match'
import { createContext, type ReactNode, useState } from 'react'
import type * as Y from 'yjs'

export const SharedDocContext = createContext<
  [Y.Doc | null | undefined, (doc: Y.Doc | null | undefined) => void]
>([null, () => undefined])

export function SharedDocProvider({ children }: { children: ReactNode }) {
  const value = useState<Y.Doc | null | undefined>(null)

  return (
    <SharedDocContext.Provider value={value}>
      {children}
    </SharedDocContext.Provider>
  )
}
